<h1 mat-dialog-title>{{ 'appSettings' | translate }}</h1>
<div mat-dialog-content>
  <p>Derzeit noch nicht verfügbar.</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'common.closeLabel' | translate }}</button>
</div>
